import { ReactElement, ReactNode } from 'react';

import { Box, Flex, IconButton, Tooltip } from '@bonusly/design-system';

interface BizySidePanelHeaderProps {
	left: ReactNode;
	pl?: number;
	right?: ReactNode;
	// Desktop MFE (Electron): make the header bar a frameless-window drag region.
	// Off by default so the web side panel is unchanged.
	isDragRegion?: boolean;
}

export function BizySidePanelHeader({ left, pl = 5, right, isDragRegion = false }: BizySidePanelHeaderProps) {
	return (
		<Flex
			align="center"
			justify="space-between"
			gap={0}
			pl={pl}
			pr={3}
			py={{ base: 4, sm: 3 }}
			flexShrink={0}
			minH="68px"
			sx={isDragRegion ? { WebkitAppRegion: 'drag' } : undefined}
		>
			<Box minW={0} flex={1} overflow="hidden">
				{left}
			</Box>
			{right && <Box flexShrink={0}>{right}</Box>}
		</Flex>
	);
}

interface BizyHeaderIconButtonProps {
	label: string;
	icon: ReactElement;
	onClick: () => void;
	color?: string;
	// Desktop MFE (Electron): exclude this control from the header drag region so
	// it stays clickable. Off by default so the web side panel is unchanged.
	isNoDrag?: boolean;
}

// The panel headers' standard tooltipped icon control (menu, minimize, close,
// settings, ...). The label doubles as the aria-label.
export function BizyHeaderIconButton({ label, icon, onClick, color = 'secondary.fg', isNoDrag = false }: BizyHeaderIconButtonProps) {
	return (
		<Tooltip label={label} hasArrow={false}>
			<IconButton
				aria-label={label}
				icon={icon}
				variant="ghost"
				size="sm"
				boxSize="32px"
				color={color}
				_hover={{ bg: 'secondary.bgAlpha' }}
				onClick={onClick}
				sx={isNoDrag ? { WebkitAppRegion: 'no-drag' } : undefined}
			/>
		</Tooltip>
	);
}
